export default function() {
  const openSearchButton = document.querySelector('#open-search-bar');
  const closeSearchButton = document.querySelector('#close-search-bar');
  const searchBar = document.querySelector('#search-bar');

  if(!openSearchButton) return;

  const widthFullClass = ['w-[calc(100%+2rem)]', 'lg:w-auto'];

  openSearchButton.addEventListener('click', () => {
    openSearchButton.setAttribute('aria-expanded', 'true');
    searchBar.classList.remove('hidden');
    searchBar.classList.add('open');

    setTimeout(() => {
      searchBar.classList.remove('w-0');
      searchBar.classList.add(...widthFullClass);
    }, 1);
  });

  closeSearchButton.addEventListener('click', () => {
    openSearchButton.setAttribute('aria-expanded', 'false');

    searchBar.addEventListener('transitionend', () => {
      searchBar.classList.add('hidden');
      searchBar.classList.remove('open');
    }, {once: true});

    searchBar.classList.remove(...widthFullClass);
    searchBar.classList.add('w-0');
  });
}
